// search result height
(function () {
  const observer = new MutationObserver(function () {
    const container = document.querySelector(".search-results-items");
    if (!container) return;

    const items = container.querySelectorAll(".search-result");
    if (items.length < 5) return;

    let totalHeight = 0;
    for (let i = 0; i < 5; i++) {
      totalHeight += items[i].offsetHeight;
    }

    container.style.maxHeight = totalHeight + "px";
    container.style.overflowY = "auto";
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
// scroll-animation start

document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll(".scroll-animation");

  function checkScroll() {
    elements.forEach((element) => {
      const rect = element.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85) {
        element.classList.add("visible");
      }
    });
  }

  window.addEventListener("scroll", checkScroll);
  checkScroll(); // Run on load in case elements are already in view
});


// scroll-animation end



// mobile menu js 

// $(".header__mobi-left-menu").on("click", function () {
//   $(this).toggleClass("active");
//   $(".header__mobi-menu").toggleClass('active');
//   $("body").toggleClass("mobile__menu-open");
// })

$(document).ready(function () {
  $(".header__mobi-left-menu").on("click", function () {
    $(this).toggleClass("active");
    $(".header__mobi-menu").toggleClass("active");
    $("body").toggleClass("mobile__menu-open");
  });
  let lastScrollTop = 0;
  $(window).on("scroll", function () {
    let scrollTop = $(this).scrollTop();
    if (scrollTop > lastScrollTop) {
      $(".menu").addClass("menu-width");
    }
    if (scrollTop === 0) {
      $(".menu").removeClass("menu-width");
    }
    lastScrollTop = scrollTop;
  });
});

// * Header Sticky
function headerSticky() {
  let lastScrollTop = 0;
  const header = document.querySelector('.header');
  if (!header) return;
  window.addEventListener('scroll', function () {
    const currentScroll = window.scrollY;
    if (currentScroll > 100) header.classList.add('header__inner_hove-active');
    else header.classList.remove('header__inner_hove-active');
    if (currentScroll === 0) header.style.transform = 'translateY(0)';
    else if (currentScroll < lastScrollTop) header.style.transform = 'translateY(0)';
    else header.style.transform = 'translateY(-100%)';
    lastScrollTop = currentScroll;
  });
}
headerSticky();

// * Header Sticky end


// Start Slick Slider

if ($(Window).width() < 768) {
  $('.why-us__items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
  });
  $('.why-us__right-slider-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
  });
}


if ($(Window).width() < 768) {
  $('.best-seller__items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
  });
  $('.best-seller__arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
  });
}




// -----------------review-card start-------------



if ($(Window).width() < 768) {
  $('.review-card__items').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  });
}


$('.review-card__arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickNext');
});




// -----------------review-card end-------------



// faq start


$(".faq-item__title").click(function () {
  if ($(this).hasClass('active')) {
    $(this).removeClass("active");
    $(this).next(".faq-item__content").slideUp();
  } else {
    $(".faq-item__content").slideUp();
    $(".faq-item__title").removeClass("active");
    $(this).addClass("active");
    $(this).next(".faq-item__content").slideDown();
  }
})

document.addEventListener('DOMContentLoaded', () => {
  const faqTrigger = document.querySelector('.faq-item__title_faq');
  const faqTarget = document.querySelector('.faq__inner_product');

  if (faqTrigger && faqTarget) {
    faqTrigger.addEventListener('click', (event) => {
      faqTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }
});
// faq end


// ---------------------footer start--------------------


if ($(Window).width() < 768) {
  $(".footer__center-item h3").click(function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass("active");
      $(this).next(".footer__center-list").slideUp();
    } else {
      $(".footer__center-list").slideUp();
      $(".footer__center-item h3").removeClass("active");
      $(this).addClass("active");
      $(this).next(".footer__center-list").slideDown();
    }
  })
}


// ---------------------footer end--------------------


// Start Product Variyent Collapes Collection Page
if ($(Window).width() < 768) {
  $(".product-variyent__shop-head").click(function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass("active");
      $(this).next(".product-variyent__shop-content").slideUp();
    } else {
      $(".product-variyent__shop-content").slideUp();
      $(".product-variyent__shop-head").removeClass("active");
      $(this).addClass("active");
      $(this).next(".product-variyent__shop-content").slideDown();
    }
  })
}


// Start Product Filtaring Collaps Collection Page
$(document).on('click', '.product-filtar__checkbox-title', function () {
  var $this = $(this);
  $this.toggleClass('active');
  $this.next('.product-filtar__checkbox-content').stop().slideToggle(200);
});

// Start Product Filtaring and shorting colection Page Mobile

if ($(Window).width() < 768) {
  $(".product-filtar__filtar-btn").on("click", function () {
    $(".product-filtar__shortbox").slideUp(300);
    $(".product-filtar__short-btn").removeClass("active");

    $(".product-filtar__selectbox").slideToggle(300, function () {
      $(".product-filtar__filtar-btn").toggleClass("active", $(this).is(":visible"));
    });
  });

  $(".product-filtar__short-btn").on("click", function () {
    $(".product-filtar__selectbox").slideUp(300);
    $(".product-filtar__filtar-btn").removeClass("active");

    $(".product-filtar__shortbox").slideToggle(300, function () {
      $(".product-filtar__short-btn").toggleClass("active", $(this).is(":visible"));
    });
  });
}

// Start Shorted Product Mobile Collection Page
if ($(Window).width() < 768) {
  var defaultText = $(".product-filtar__shortlist a.active").text();
  $(".product-filtar__short-btn p").text(defaultText);
  $(".product-filtar__shortlist a").on("click", function (e) {
    e.preventDefault();
    $(".product-filtar__shortlist a").removeClass("active");
    $(this).addClass("active");
    $(".product-filtar__short-btn p").text($(this).text());
  });
}

// Start Shorted Product Desktop collection Page
$(document).ready(function () {
  var $activeSortLink = $(".product-filtar__shortlisted-desk a.active");
  if ($activeSortLink.length) {
    var activeSortText = $activeSortLink.text().trim();
    $(".product-filtar__shortedbtn p").text(activeSortText);
  }
  if ($(window).width() > 768) {
    $(document).on("click",".product-filtar__shortedbtn",function() {
        $(".product-filtar__shortlisted-desk").slideToggle(150);
      $(this).toggleClass("active");
    });

    // $(".product-filtar__shortedbtn").on("click", function () {
    //   $(".product-filtar__shortlisted-desk").slideToggle(150);
    //   $(this).toggleClass("active");
    // });

    $(".product-filtar__shortlisted-desk a").on("click", function (e) {
      e.preventDefault();

      $(".product-filtar__shortlisted-desk a").removeClass("active");
      $(this).addClass("active");
      $(".product-filtar__shortedbtn p").text($(this).text());
      $(".product-filtar__shortlisted-desk").slideUp(150);
      $(".product-filtar__shortedbtn").removeClass("active");

    });
  }
});


// Product Slider Product Page
$('.product__view-img').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: false,
  adaptiveHeight: true,
  asNavFor: '.product__thumb-items',
  responsive: [{
    breakpoint: 768,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }, ]
});
$('.product__thumb-items').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  vertical: true,
  asNavFor: '.product__view-img',
  centerMode: false,
  focusOnSelect: true,
  arrows: false,
  infinite: true,
  responsive: [{
    breakpoint: 768,
    settings: {
      vertical: false,
      slidesToShow: 4,
      slidesToScroll: 1
    }
  }, ]
});

$('.product__left-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.product__right-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickNext');
});


// Start Benefits Product Page
if ($(Window).width() < 768) {
  $('.benefits__items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
  });
  $('.benefits__right-slider-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
  });
}


$('.product__view-zoom').on('click', function () {
  $("body").addClass('popup-show');
});
$('.close-popup , .overlay-bg').on('click', function () {
  $("body").removeClass('popup-show');
});

$('.product__view-zoom').on('click', function () {
  const currentImg = $('.product-view-item.slick-current img').attr('src');
  $('.popup-img').attr('src', currentImg);
  $('.image-popup').fadeIn(200);
});





// ---------------details start-----------

if ($(Window).width() < 768) {
  $('.details__items').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
  });
  $('.details__arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
  });
}


$('.details__bottom-btn').on('click', function () {
  $('.supplement-details').toggleClass('active');
  $(this).toggleClass('active');
});



// ---------------details end-----------



// ---------------------cart start-----------------



$('.cart__product-add-items').slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});




$(".header__right-cart").on('click', function () {
  $("body").addClass('cart-open');
  $(".header__mobi-menu-wrap").removeClass('active');
})
$(".cart__top-cross-img , .overlay-bg").on('click', function () {
  $("body").removeClass('cart-open');
})
$(".header__right-cart").on('click', function () {
  $("body").removeClass('mobile__menu-open');
  $(".header__mobi-menu").removeClass('active');
})
// ---------------------cart end-----------------



// menu start



$(".menu__has-sub").click(function () {
  if ($(this).hasClass('active')) {
    $(this).removeClass("active");
    $(this).next(".menu__sub-menu").slideUp();
  } else {
    $(".menu__sub-menu").slideUp();
    $(".menu__has-sub").removeClass("active");
    $(this).addClass("active");
    $(this).next(".menu__sub-menu").slideDown();
  }
})


// menu end


// sticky-btn start



document.addEventListener("DOMContentLoaded", function () {
  const heroSection = document.querySelector(".hero , .product");
  const stickyBtn = document.querySelector(".sticky-btn");

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          stickyBtn.classList.add("visible");
        } else {
          stickyBtn.classList.remove("visible");
        }
      });
    }, {
      root: null,
      threshold: 0
    }
  );

  if (heroSection) {
    observer.observe(heroSection);
  }
});




// sticky-btn end



// modal start


$(document).ready(function () {
  $('.review-card__video-play-icon').on('click', function () {
    let videoSrc = $(this).find('video source').attr('src');
    if (!videoSrc) {
      videoSrc = $(this).closest('.review-card__item-img').find('video source').attr('src');
    }

    const modal = $('.modal');
    const modalVideo = $('.modal__video video')[0];

    $('body').addClass('modal-active');

    modalVideo.src = videoSrc;

    requestAnimationFrame(() => {
      modal.addClass('show');
      modalVideo.currentTime = 0;
      modalVideo.play().catch(() => {});
    });
  });

  $('.modal__close, .overlay-bg').on('click', function () {
    const modalVideo = $('.modal__video video')[0];
    modalVideo.pause();
    modalVideo.currentTime = 0;

    $('body').removeClass('modal-active');
    $('.modal').removeClass('show');
  });
});




// modal end


// Collection filter start

var my_filter = {};
var s_filter_val = {};
var sortValue = '';

function sortFilter() {
  var filter_path = window.location.pathname;
  var s_filter = '';
  var filter_count = 0;

  $('.filters__input:checked').each(function (index) {
    s_filter += '&' + $(this).attr('name') + '=' + $(this).val();
    filter_count++;
  });

  if ($('.filters__input_price:checked').length >= 2) {
    filter_count--;
  }

  filter_path = filter_path + '?' + s_filter + '&sort_by=' + sortValue;

  fetch(filter_path + '&section_id=la-main-collection')
    .then(function (response) { return response.text(); })
    .then(function (collectionData) {
      var $res = $('<div>').html(collectionData);
      var $section = $('.product-filtar').first();
      if (!$section.length) return;

      var $newItemsWrap = $res.find('.product-filtar__items-wrap').first();
      var $newSelectbox = $res.find('.product-filtar__selectbox').first();

      if ($newItemsWrap.length) {
        $section.find('.product-filtar__items-wrap').first().replaceWith($newItemsWrap[0].outerHTML);
      }
      if ($newSelectbox.length) {
        $section.find('.product-filtar__selectbox').first().replaceWith($newSelectbox[0].outerHTML);
      }

      var hasProducts = $section.find('.product-card_collection').length > 0;
      $section.find('.product-filtar__product-not-found').toggle(!hasProducts);
      var $activeSort = $section.find('.product-filtar__shortlisted-desk a.active');
      if ($activeSort.length) $section.find('.product-filtar__shortedbtn p').text($activeSort.text().trim());
    });

  if (filter_count >= 1) {
    $('.filter-count').text('(' + filter_count + ')');
  } else {
    $('.filter-count').text('');
  }
}

$(document).on("click",".product-filtar__shortlisted-desk .select__select",function() {
        sortValue = $(this).attr('data-sort-value');
        sortFilter();
    });

    $(document).on("click",".product-filtar__shortlist .select__select",function() {
        sortValue = $(this).attr('data-sort-value');
        sortFilter();
    });


$(document).on('change', '.filters__input', function () {
  sortFilter();
});

// Collection filter end


// Cart Start

function get_cart_details() {
  fetch("?section_id=cart-drawer")
    .then((response) => response.text())
    .then((cartData) => {
      var cart_html = $(cartData);
      var cart_items = $(".cart__wrapper", cart_html);
      $(".cart__wrapper").replaceWith(cart_items);

      var cart_items = $(".cart__top-item-add-text span", cart_html);
      $(".cart__top-item-add-text span").replaceWith(cart_items);

      if ($('.cart__product-add-items').length) {
        $('.cart__product-add-items').slick({
          dots: true,
          arrows: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true
        });
      }

    });

  fetch("?section_id=la-header")
    .then((response) => response.text())
    .then((cartData) => {
      var cart_html = $(cartData);
      var cart_count = $(".header__right-cart span", cart_html);
      $(".header__right-cart span").replaceWith(cart_count);

    });
};

//  Increase quantity
function increaseCount1(e, el) {
  var $input = el.previousElementSibling;
  var value = parseInt($input.value, 10);
  value = isNaN(value) ? 0 : value;
  value++;
  $input.value = value;
  change_qty($input);
  if (value > 1) {
    $(".product__quantity-minus").addClass("active");
  }
}

//  Decrease quantity
function decreaseCount1(e, el) {
  var $input = el.nextElementSibling;
  var value = parseInt($input.value, 10);
  if (value > 1) {
    value = isNaN(value) ? 0 : value;
    value--;
    $input.value = value;
    change_qty($input);
  }
  if (value == 1) {
    $(".product__quantity-minus").removeClass("active");
  }
}

//  Add to Cart from Product single page
$(".product__btn").on("click", function (e) {
  e.preventDefault();
  formData = $(this).parent().parent().parent().parent().find(".single-product-form").serialize();
  addToCart(formData)
});

function addToCart(formData) {
  //   console.log(formData);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: formData,
    success: function (data) {
      $("body").addClass("cart-open");
      get_cart_details();
    },
    error: function (err) {
      console.log(err);
    },
  });
};

// Update quantity
function change_qty($input) {
  var variant_id = $($input).attr("data-id");
  var quantity = $($input).val();
  // console.log(variant_id);
  var data = {
    updates: {}
  };
  data.updates[variant_id] = quantity;
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function (res) {
      get_cart_details();
    }
  });
};

// Remove cart item from Cart Drawer
function itemRemove(e, el) {
  e.preventDefault();
  var variant_id = $(el).attr("data-id");
  // console.log(variant_id);
  var data = {
    updates: {}
  };
  data.updates[variant_id] = '0';
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function (res) {
      get_cart_details();
    }
  });
  $(el).parent().parent().parent().parent().parent().parent().remove();
}


// Upsell product item cart

// $(".cart_addon_product_btn").on("click", function (e) {
// });

$(document).on("click", ".cart_addon_product_btn", function (e) {
  e.preventDefault();
  formData = $(this).parent().parent().parent().find(".cart-product-form").serialize();
  addCartDrawer(formData);
});

function addCartDrawer(formData) {
  // console.log(formData);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: formData,
    success: function (data) {
      // console.log(data)
      // $("body").addClass("cart-open");
      get_cart_details();
    },
    error: function (err) {
      console.log(err);
    },
  });
};



function handleVariantChange(event) {
  let $triggerElement;
  
  if (event && event.target) {
    $triggerElement = $(event.target);
  } else {
    $triggerElement = $('.product__color-items input[type="radio"]:checked, .product__variant-radio:checked').first();
  }

  if (!$triggerElement.length) return;

  const selectedValue = $triggerElement.val();
  
  if (event && event.target) {
    const $parentContainer = $triggerElement.closest('.product__color, .product__variant-options');
    const $labelUpdate = $parentContainer.find('h5 em');
    if ($labelUpdate.length) {
      $labelUpdate.text(selectedValue);
    }
  }

  const $allCheckedInputs = $('.product__color-items input[type="radio"]:checked, .product__variant-radio:checked');
  const combinedValue = $allCheckedInputs.map(function() {
    return $(this).val();
  }).get().join(' / ');

  const $selectOptions = $('.select-variant option');
  const $matchedOption = $selectOptions.filter(function() {
    const optionValue = ($(this).val() || $(this).text()).trim().toLowerCase();
    return optionValue === combinedValue.toLowerCase();
  }).first();

  if (!$matchedOption.length) return;

  const $selectEl = $('.select-variant');
  if ($matchedOption.length && $selectEl.length) {
    $selectEl.val($matchedOption.val() || $matchedOption.text());
    $matchedOption.prop('selected', true);
  }

  const priceCompare = $matchedOption.attr('data-price-compare');
  const price = $matchedOption.attr('data-price');
  const discount = $matchedOption.attr('data-discount-price');

  // Only update compare price if it exists
  if (priceCompare) {
    $('.product__prev-price h4').text(priceCompare);
  }
  
  if (price) {
    $('.product__current-price h4').text(price);
  }
  
  // Only update discount if savings percentage is greater than 0
  if (discount && !discount.includes('NaN')) {
    $('.product__discount-price h4').text(discount);
  } else {
    $('.product__discount-price').hide();
  }

  const isAvailable = $matchedOption.attr('data-available') === 'true';
  const $addToCartBtn = $('.product__btn');
  if ($addToCartBtn.length) {
    $addToCartBtn.toggleClass('btn-disabled', !isAvailable);
  }

  const variantId = $matchedOption.attr('id');
  const variant = window.productVariants?.find(v => v.id == variantId);
  
  if (variant?.featured_image) {
    const imageId = variant.featured_image.id;
    const $mainSlider = $('.product__view-img');
    const $thumbSlider = $('.product__thumb-items');
    const $targetSlide = $mainSlider.find('.product-view-item[data-image-id="' + imageId + '"]').not('.slick-cloned').first();
    const targetIndex = $targetSlide.data('slick-index');
    
    if (targetIndex !== undefined && targetIndex !== null) {
      $mainSlider.slick('slickGoTo', targetIndex);
      $thumbSlider.slick('slickGoTo', targetIndex);
    }
  }
  if (variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({ path: url.href }, '', url.href);

    const $hiddenInput = $('.product__addtocard input[name="id"]');
    if ($hiddenInput.length) {
      $hiddenInput.val(variantId);
    }
  }
}

$('.product__color-items input[type="radio"], .product__variant-radio').on('change', handleVariantChange);


$(document).ready(function() {
  handleVariantChange();
});
$(document).ready(function() {
  $(".product__variant-guide-link").on("click" , function() {
  $(".modal-learn-more").addClass("show");

});

  $(".modal-learn-more__close-btn, .modal-learn-more__overlay").on("click", function() {
    $(".modal-learn-more").removeClass("show");
   
  });

});

// $(document).on("click", ".product__variant-guide-link", function(e) {
//   e.preventDefault();
//   $(".modal-learn-more").addClass("show");

// });


$(".header__mobi-left-search , .header__right-search .header__right-img").on("click" , function() {
  $("body").addClass("searchbar-show");
})
$(".searchbar__close").on("click" , function() {
  $("body").removeClass("searchbar-show");
})


